import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import LinkOffIcon from "@material-ui/icons/LinkOff";

import axios from "axios";
import ConfirmationModal from "views/components/ConfirmationModal";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";

const BlackListPinCodes = (props) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns] = useState([
    { id: "pincode", label: "PinCodes" },
    { id: "action", label: "Actions" },
  ]);
  const [templateData, setTemplateData] = useState(["PinCodes"]);
  const [rawData, setRawData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deletePinCodeId, setDeletePinCodeId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const handleCreateBlackListPinCode = async () => {
    navigate(`/coreservice/BlackListPinCode-create`);
  };
  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_BLACK_LIST_PINCODE_FIND,
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };
  const parseIndicatorData = (data) => {
    let reportData = [];
    let downloadData = [];
    downloadData.push(templateData);
    data.forEach((pin, i) => {
      let row = {
        pincode: pin.pincode,
        action: getIcons(pin.pincode),
      };
      reportData.push(row);
      downloadData.push(pin);
    });
    setSelectedTableData(reportData);
  };
  // icons function calling
  const getIcons = (pincode, branchCode) => {
    return (
      <>
        <IconButton
          aria-label="Delete PinCode"
          onClick={() => onClickDeleteData(pincode)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };

  // delete function
  const onClickDeleteData = (pincode) => {
    setConfirmationModalHeader("Black List PinCode");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeletePinCodeId(pincode);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeletePinCodeId("");
  };
  const handlePositiveResponse = async () => {
    const PinCodeId = deletePinCodeId;
    handleNegativeResponse();
    const URL =
      endpoint.BASE_URL_STAGING + "/" + endpoint.MASTER_BLACK_LIST_PINCODE_DELETE;
    const res = await axios.delete(URL, {
      headers: {
        Authorization: "Bearer " + authToken,
      },
      data: {
        pincodes: [PinCodeId],
      },
    });
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Error", "Delete PinCode is successful", true);
      GetData();
    }
  };

  // serach function calling
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        row.pincode.toLowerCase().includes(val.toLowerCase()) ||
        (row.branchName &&
          row.branchName.toLowerCase().includes(val.toLowerCase()))
      );
    });
    parseIndicatorData(filteredData);
  };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label="Black List PinCode"
          button1="Create Black List PinCode"
          button1click={handleCreateBlackListPinCode}
          onSearchChange={onSearchChange}
          searchLabel="Search For Black List PinCode"
          search
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={tableColumns} rows={selectedTableData} />
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

BlackListPinCodes.propTypes = {
  classes: PropTypes.object,
};

export default BlackListPinCodes;
